// import Vue from "vue";
export default {
  closeAll(state) {
    state.navActive = false;
    state.callMeActive = false;
  }
};
